import React, { useEffect, useMemo, useRef, useState } from 'react';
import DefaultLayout from '../../layout/DefaultLayout';
import { useNavigate, useLocation } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumb';

const isMobileDevice = () => /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');

const VerificarSupervivenciaAWS: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [openedExternal, setOpenedExternal] = useState(false);

  const query = new URLSearchParams(location.search);
  const idBeneficiario = query.get('idBeneficiario') ?? '';
  const idTipoBeneficio = query.get('idTipoBeneficio') ?? '';
  const tipoTramiteSupervivencia = query.get('tipoTramiteSupervivencia') ?? '';
  const periodo = query.get('periodo') ?? '';

  // Stable anti-cache value for this component lifecycle
  const antiCacheRef = useRef(Date.now());

  const baseApi = process.env.REACT_APP_API_URL ?? '';

  const livenessUrl = useMemo(() => {
    const livenessUri = baseApi.includes('localhost')
      ? `/liveness?`
      : `/liveness/index.html?${antiCacheRef.current}&`;

    return (
      baseApi +
      livenessUri +
      `idBeneficiario=${encodeURIComponent(idBeneficiario)}&idTipoBeneficio=${encodeURIComponent(
        idTipoBeneficio
      )}&tipoTramiteSupervivencia=${encodeURIComponent(tipoTramiteSupervivencia)}&periodo=${encodeURIComponent(
        periodo
      )}`
    );
  }, [baseApi, idBeneficiario, idTipoBeneficio, tipoTramiteSupervivencia, periodo]);

  useEffect(() => {
    if (isMobileDevice()) {
      try {
        window.open(livenessUrl, '_blank', 'noopener');
        setOpenedExternal(true);
      } catch {
        // ignore
      }
    }
  }, [livenessUrl]);

  return (
    <DefaultLayout>
      <Breadcrumb pageName="Supervivencia" />
      <div className="p-6">
        {openedExternal ? (
          <div className="bg-white dark:bg-boxdark p-6 rounded">
            <p className="text-sm text-gray-700 mb-4">
              El trámite fue abierto en una nueva pestaña. Una vez finalizado, volverás a esta pantalla para ver el
              resultado en "Supervivencia".
            </p>
            <button
              onClick={() => navigate('/')}
              className="px-4 py-2 rounded bg-primario-celeste-800 text-white hover:bg-primario-azul-900"
            >
              Volver al inicio
            </button>
          </div>
        ) : (
          <div style={{ height: '100vh', borderRadius: 8, overflow: 'hidden' }}>
            <iframe
              title="Verificación Supervivencia"
              src={livenessUrl}
              width="100%"
              height="100%"
              style={{ border: 'none' }}
              allow="camera; microphone; clipboard-read; clipboard-write; autoplay; encrypted-media"
            />
          </div>
        )}
      </div>
    </DefaultLayout>
  );
};

export default VerificarSupervivenciaAWS;